<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search"
        >
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>Crews</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>                
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <template v-slot:activator="{ on, attrs }" v-if="$store.state.currentPagePriv.create">
                    <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                      New Crew
                    </v-btn>
                </template>
                <v-card>
                    <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text>
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                        <v-col cols="12" sm="6" md="6">
                            <span>Code</span>
                            <v-text-field maxlength="10" v-model="editedItem.code" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex>-1" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Nik</span>
                            <v-text-field v-model="editedItem.nik" filled rounded dense hide-details="auto" @keydown.space.prevent :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Crew Name</span>
                            <v-text-field v-model="editedItem.crew_name" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Outlet Code</span>
                            <v-select filled rounded dense :items="outlets" item-text="name" item-value="code" v-model="editedItem.outlet_code" :rules="reqRule"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <span>Status</span>
                            <v-checkbox v-model="editedItem.status"></v-checkbox>
                        </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4">Training Topic</v-col>
                          <v-col cols="3">Training Date</v-col>
                          <v-col cols="2"></v-col>
                        </v-row>
                        <v-row v-for="(obj, idx) in editedItem.details" :key="idx">
                          <v-col cols="4">
                            <v-autocomplete filled rounded dense :items="trainings" item-text="training_topic" item-value="code" v v-model="obj.training_code" hide-details="auto" @change="fillTrainings(obj)" autocomplete="off" :rules="reqRule" auto-select-first></v-autocomplete>
                          </v-col>
                          <v-col cols="5">
                            <v-menu v-model="datepicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="obj.training_date" filled rounded dense hide-details="auto" :rules="reqRule" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                                </template>
                                <v-date-picker v-model="obj.training_date" @input="datepicker = false"></v-date-picker>
                              </v-menu>
                          </v-col>
                          <v-col cols="2">
                            <v-icon color="red" class="pt-1" @click="removeTrainings(idx)">
                                mdi-minus-circle-outline
                            </v-icon>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold body-1 pl-4"></v-col>
                          <v-col cols="3" class="font-weight-bold body-1 pl-4"></v-col>
                          <v-col cols="3"></v-col>
                          <v-col cols="2" class="">
                            <v-btn color="primary" outlined text @click="addTrainings()">Add</v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-container>
                    </v-card-text>
                    <v-divider></v-divider>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        Cancel
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                        Save
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                    <v-card-title class="body-1 text-center">Anda akan menghapus Crew ini?</v-card-title>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDetail" max-width="700px">
                <v-card>
                    <v-card-title class="">
                      <span class="text-h6">Crew Detail</span>
                      <v-spacer></v-spacer>
                      <v-icon color="white" @click="dialogDetail = false">mdi-close</v-icon>
                    </v-card-title>
                    <v-divider></v-divider>

                    <v-card-text class="pt-4">
                    <v-container>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Code:</v-col>
                          <v-col cols="8">{{ detailItem.code }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">NIK:</v-col>
                          <v-col cols="8">{{ detailItem.nik }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Crew Name:</v-col>
                          <v-col cols="8">{{ detailItem.crew_name }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Outlet:</v-col>
                          <v-col cols="8">{{ getOutlateName(detailItem.outlet_code) }}</v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="4" class="font-weight-bold">Status:</v-col>
                          <v-col cols="8">
                            <v-chip small :color="detailItem.status ? 'green' : 'red'" text-color="white">
                              {{ detailItem.status ? 'Active' : 'Inactive' }}
                            </v-chip>
                          </v-col>
                        </v-row>
                        <v-divider class="my-3"></v-divider>
                        <v-row>
                          <v-col cols="12" class="font-weight-bold text-h6">Training History</v-col>
                        </v-row>
                        <v-row v-if="detailItem.pivots && detailItem.pivots.length > 0">
                          <v-col cols="12">
                            <v-simple-table dense>
                              <template v-slot:default>
                                <thead>
                                  <tr>
                                    <th class="text-left">No</th>
                                    <th class="text-left">Training Topic</th>
                                    <th class="text-left">Training Date</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(training, idx) in detailItem.pivots" :key="idx">
                                    <td>{{ idx + 1 }}</td>
                                    <td>{{ getTrainingTopic(training.training_code) }}</td>
                                    <td>{{ formatDate(training.training_date) }}</td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                        </v-row>
                        <v-row v-else>
                          <v-col cols="12" class="text-center grey--text">
                            Belum ada training
                          </v-col>
                        </v-row>
                    </v-container>
                    </v-card-text>

                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogDetail = false">
                        Close
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
            <v-icon small class="mr-2" @click="viewDetail(item)">
                mdi-eye
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                mdi-delete
            </v-icon>
            </template>
            <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">
                Reset
            </v-btn>
            </template>
            <template v-slot:[`item.outlet_code`]="{ item }">
              {{getOutlateName(item.outlet_code)}}
            </template>
        </v-data-table>
        <v-overlay :value="onProgress" z-index="999">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>        
        <v-snackbar top v-model="saved" color="green">Data berhasil tersimpan!</v-snackbar>
        <v-snackbar top v-model="saveError" color="red accent-2">Data gagal tersimpan! Mohon pastikan data yang akan disimpan sudah sesuai.</v-snackbar>
    </div>
</template>

<script>
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      dialogDetail: false,
      detailItem: {},
      headers: [
        { text: 'Code', value: 'code' },
        { text: 'Nik', value: 'nik' },
        { text: 'Crew Name', value: 'crew_name' },
        { text: 'Outlet', value: 'outlet_code' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      items: [],
      outlets: [],
      editedIndex: -1,
      editedItem: {
        status: true,
        details: []
      },
      defaultItem: {
        status: true,
        details: []
      },
      search: '',
      trainings: [],
      reqRule: [v => !!v || 'Harus diisi!'],
      valid: true,
      outletCode: [],
      onProgress: false,
      saved: false,
      saveError: false,
      datepicker: false,
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Crew' : 'Edit Crew'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      async initialize () {
        try {
          // Load outlets, tapi jika user gak punya akses tetap lanjut
          const outletResponse = await this.$store.dispatch('outlet/getObjs')
          this.outlets = outletResponse.data.data || []
        } catch (error) {
          console.warn('Tidak dapat memuat data outlet:', error)
          this.outlets = []
        }

        try {
          // Load trainings
          const trainingResponse = await this.$store.dispatch('training/getObjs')
          this.trainings = trainingResponse.data.data || []
        } catch (error) {
          console.warn('Tidak dapat memuat data training:', error)
          this.trainings = []
        }

        // Load crews - ini yang penting
        let response = await this.$store.dispatch('crew/getObjs')
        if (response.data.status=='success') this.items = response.data.data
      },
      getOutlateName(code) {
        // Jika outlets tidak ada atau kosong, tampilkan code-nya
        if (!this.outlets || this.outlets.length === 0) {
          return code || '-';
        }
        
        const outlet = this.outlets.find(element => {
          return element.code == code
        });
        
        // Jika outlet ditemukan, tampilkan name. Jika tidak, tampilkan code
        return outlet ? outlet.name : (code || '-');
      },

      getTrainingTopic(code) {
        const training = this.trainings.find(element => {
          return element.code == code
        });
        return training ? training.training_topic : '-';
      },

      formatDate(date) {
        if (!date) return '-';
        const d = new Date(date);
        return d.toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' });
      },

      viewDetail(item) {
        this.detailItem = Object.assign({}, item);
        this.dialogDetail = true;
      },

      fillTrainings(obj) {
        obj.training_topic = (this.trainings.find(element=> {
          return element.code == obj.code
        })).training_topic
      },

      addTrainings() {
        let details = {training_code: '', training_date: ''}
        this.editedItem.details.push(details)
      },

      removeTrainings(idx) {
        this.editedItem.details.splice(idx, 1)
      },

      async editItem (item) {
        this.onProgress = true
        this.editedItem = {
          code: item.code,
          nik: item.nik,
          crew_name: item.crew_name,
          outlet_code: item.outlet_code,
          status: item.status,
          details: []
        }
        item.pivots.forEach(element => {
          this.editedItem.details.push({
            training_code: element.training_code,
            training_date: element.training_date
          })
        });
        this.editedIndex = this.items.indexOf(item)
        this.dialog = true
        this.onProgress = false
      },
      
      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      async deleteItemConfirm () {
        let url = this.$store.state.config.apiHost + "crews/" + this.editedItem.code
        let response = await this.$axios.delete(url, {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
        if (response.data.status=='success') this.items.splice(this.editedIndex, 1)
        this.closeDelete()
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      async save () {
        await this.$refs.form.validate();
        if (!this.valid) return;

        if (this.editedIndex > -1) {
          let url = this.$store.state.config.apiHost + "crews/" + this.editedItem.code
          let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
          if (response.data.status=='success') Object.assign(this.items[this.editedIndex], this.editedItem)
          this.close()
          
        } else {
          try {
            let url = this.$store.state.config.apiHost + "crews"
            let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
            if (response.data.status=='success') this.items.push(this.editedItem)
            this.close()
          }
          catch (err) {
            const keyword = 'duplicate key'
            if (err.response.data.message.search(keyword) > -1){
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
            }
            else {
              return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
            }
          }

        }
      },
    },
  }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

</style>